// Core packages
import { Component, Inject } from "@angular/core";

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

// Custom packages

@Component({
  selector: "app-lightbox-dialog",
  templateUrl: "./lightbox-dialog.component.html",
  styleUrls: ["./lightbox-dialog.component.scss"]
})
export class LightboxDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LightboxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   * Handle dialog close
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
